import A11yDialog from "a11y-dialog";

var wmbb = {
  headerForm: function () {
    var btn = document.getElementById("header-form-toggle");

    if (!btn) {
      return;
    }

    var form = btn.nextElementSibling;
    var input = form.querySelector("input");

    function openNav() {
      btn.setAttribute("aria-expanded", true);
      form.classList.add("open");
      input.focus();
    }
    function closeNav() {
      btn.setAttribute("aria-expanded", false);
      form.classList.remove("open");
    }

    btn.addEventListener(
      "click",
      function (event) {
        if (this.getAttribute("aria-expanded") === "true") {
          closeNav();
        } else {
          openNav();
        }
      },
      false
    );
  },
  mobileNav: function () {
    var navBtn = document.getElementById("btn-site-nav");

    if (!navBtn) {
      return;
    }

    var nav = document.getElementById("site-navigation");
    // var nav = navBtn.nextElementSibling; //#site-navigation
    var drawer = navBtn.parentNode;
    var outerWrapper = drawer.parentNode;

    var focusable = nav.querySelectorAll(
      "li.last-branch > a, li.last-branch > button"
    );

    function lastVisibleIndex(array) {
      var last_visible_index = false;
      array.forEach(function (element, idx, arr) {
        // returns null if this element or parent has display:none;
        if (element.offsetParent) {
          last_visible_index = idx;
        }
      });
      return last_visible_index;
    }

    function openNav() {
      //navBtn.classList.add("active");
      navBtn.setAttribute("aria-expanded", true);
      nav.classList.add("active");
      outerWrapper.classList.add("nav-open");
    }
    function closeNav() {
      //navBtn.classList.remove("active");
      navBtn.setAttribute("aria-expanded", false);

      nav.classList.remove("active");
      outerWrapper.classList.remove("nav-open");
    }

    navBtn.addEventListener(
      "click",
      function (event) {
        if (this.getAttribute("aria-expanded") === "true") {
          closeNav();
        } else {
          openNav();
        }
      },
      false
    );

    navBtn.addEventListener(
      "keydown",
      function (e) {
        if (e.key === "Tab" && e.shiftKey) {
          e.preventDefault();
          focusable[lastVisibleIndex(focusable)].focus();
        }
      },
      false
    );

    focusable.forEach(function (element, idx, array) {
      element.addEventListener(
        "keydown",
        function (e) {
          // bail if nav button is hidden (large screens)
          if (!navBtn.offsetParent) {
            return;
          }

          if (idx === lastVisibleIndex(focusable)) {
            if (e.key === "Tab" && !e.shiftKey) {
              e.preventDefault();
              navBtn.focus();
            }
          }
        },
        false
      );
    });

    function expandSubMenu(subMenu) {
      // set submenu's height to zero before transition to full height
      subMenu.style.height = 0;
      // sets display:block;
      subMenu.classList.add("show");
      // get the height of the submenu's contents
      var fullHeight = subMenu.scrollHeight;
      // change height from 0 to full height
      subMenu.style.height = fullHeight + "px";
      subMenu.style.overflow = "hidden";

      function onTransitionEnd() {
        // remove this event listener so it only gets triggered once
        subMenu.removeEventListener("transitionend", onTransitionEnd);
        subMenu.style = null;
      }
      // when the next css transition finishes (which should be the one we just triggered)
      subMenu.addEventListener("transitionend", onTransitionEnd);
    }
    function collapseSubMenu(subMenu) {
      // get the height of the subMenu's inner content
      var sectionHeight = subMenu.scrollHeight;

      // temporarily disable all css transitions
      var elementTransition = subMenu.style.transition;
      subMenu.style.transition = "";

      subMenu.style.overflow = "hidden";

      // on the next frame (as soon as the previous style change has taken effect),
      // explicitly set the element's height to its current pixel height, so we
      // aren't transitioning out of 'auto'
      requestAnimationFrame(function () {
        subMenu.style.height = sectionHeight + "px";
        subMenu.style.transition = elementTransition;

        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(function () {
          function onTransitionEnd() {
            // remove this event listener so it only gets triggered once
            subMenu.removeEventListener("transitionend", onTransitionEnd);

            subMenu.classList.remove("show");
            subMenu.style = null;
          }
          // when the next css transition finishes (which should be the one we just triggered)
          subMenu.addEventListener("transitionend", onTransitionEnd);
          subMenu.style.height = 0 + "px";
        });
      });
    }

    const subMenuBtns = document.querySelectorAll(".btn-submenu");
    subMenuBtns.forEach(function (btn, idx, array) {
      var subMenu = btn.nextElementSibling; // .main-menu__panel;
      

      // var subMenu = btn.parentNode.querySelector(".main-menu__panel");
      btn.onclick = () => {
        console.log("btn clicked", btn, subMenu);
        
        if (btn.getAttribute("aria-expanded") === "true") {
          btn.setAttribute("aria-expanded", false);
          collapseSubMenu(subMenu, btn);
        } else {
          btn.setAttribute("aria-expanded", true);
          expandSubMenu(subMenu, btn);
        }
      };
    });

    // Escape key
    document.addEventListener(
      "keyup",
      function (e) {
        if (e.type === "keyup" && e.key === "Escape") {
          closeNav();
        }
      },
      false
    );

    // nav.addEventListener(
    //   "click",
    //   function (event) {
    //     closeNav();
    //   },
    //   false
    // );
    // nav.children()[0].addEventListener(
    //   "click",
    //   function (event) {
    //     event.stopPropagation();
    //   },
    //   false
    // );

    // navItems.on("click", function (e) {
    //   navItems.not($(this)).removeClass("open");
    //   $(this).toggleClass("open");
    // });
    // navItems.find("a").on("click", function (e) {
    //   e.stopPropagation();
    // });

    //console.log(nav);
  },
  modals: function () {
    MicroModal.init({
      disableFocus: true,
      onShow: function (modal, trigger) {
        if (trigger.dataset.doHistory) {
          history.pushState({}, null, trigger.hash);
        }
      },
      onClose: function (modal, trigger) {
        if (trigger.dataset.doHistory) {
          history.pushState({}, null, " ");
        }
      },
    });

    document
      .querySelectorAll("a[data-micromodal-trigger]")
      .forEach(function (link) {
        link.addEventListener("click", function (e) {
          e.preventDefault();
        });

        if (window.location.hash && window.location.hash == link.hash) {
          MicroModal.show(link.dataset.micromodalTrigger);
        }
      });

    var liveModal = document.getElementById("live-modal");
    if (liveModal) {
      MicroModal.show(liveModal.id, {
        disableFocus: true,
      });
    }
  },
  carousels: function () {
    (function ($) {
      //alert(0);

      $(".glide").each(function () {
        if ($(this).find(".glide__slide").length < 2) {
          return;
        }

        var glide = new Glide($(this)[0], {
          type: "carousel",
          perView: 4,
          autoplay: 2000,
          gap: 20,
          startAt: 0,

          rewind: false,
          breakpoints: {
            1200: {
              perView: 3,
            },
            860: {
              perView: 2,
            },
            650: {
              perView: 1,
            },
          },

          // focusAt: "center",
          // dragThreshold: false,
          // peek: {
          //   before: 160,
          //   after: 160,
          // },
        });

        glide.mount();
      });
    })(jQuery);
  },
  accordion: function () {
    function collapse(p) {
      let btn = p.querySelector("button");

      if (btn.getAttribute("aria-expanded") === "true") {
        let element = p.querySelector(".accordion__content");
        btn.setAttribute("aria-expanded", false);

        // get the height of the element's inner content, regardless of its actual size

        var sectionHeight = element.scrollHeight;

        // temporarily disable all css transitions
        var elementTransition = element.style.transition;
        element.style.transition = "";

        // on the next frame (as soon as the previous style change has taken effect),
        // explicitly set the element's height to its current pixel height, so we
        // aren't transitioning out of 'auto'
        requestAnimationFrame(function () {
          element.style.height = sectionHeight + "px";
          element.style.transition = elementTransition;

          // on the next frame (as soon as the previous style change has taken effect),
          // have the element transition to height: 0
          requestAnimationFrame(function () {
            element.style.height = 0 + "px";
          });
        });
      }
    }

    function expand(p) {
      let btn = p.querySelector("button");
      let element = p.querySelector(".accordion__content");

      btn.setAttribute("aria-expanded", true);
      element.hidden = false;

      // get the height of the element's inner content, regardless of its actual size
      var sectionHeight = element.scrollHeight;

      // have the element transition to the height of its inner content
      element.style.height = sectionHeight + "px";

      function onTransitionEnd() {
        // remove this event listener so it only gets triggered once
        element.removeEventListener("transitionend", onTransitionEnd);

        // remove "height" from the element's inline styles, so it can return to its initial value
        element.style.height = null;
      }
      // when the next css transition finishes (which should be the one we just triggered)
      element.addEventListener("transitionend", onTransitionEnd);

      element.hidden = false;
    }

    const popovers = document.querySelectorAll(".accordion__item");

    Array.prototype.forEach.call(popovers, (h) => {
      let btn = h.querySelector(".accordion-button");
      h.querySelector(".accordion__content").style.height = 0;

      btn.onclick = () => {
        h.classList.toggle("expanded");

        if (btn.getAttribute("aria-expanded") === "true") {
          collapse(h);
        } else {
          expand(h);
          // Array.prototype.forEach.call(popovers, (s) => {
          //   if (s != h) collapse(s);
          // });
        }
      };
    });
  },
  newAccordion: function () {
    function collapse(btn, element) {
      //let btn = p.querySelector("button");

      if (btn.getAttribute("aria-expanded") === "true") {
        //let element = p.querySelector(".accordion__content");
        btn.setAttribute("aria-expanded", false);

        // get the height of the element's inner content, regardless of its actual size

        var sectionHeight = element.scrollHeight;

        // temporarily disable all css transitions
        var elementTransition = element.style.transition;
        element.style.transition = "";

        // on the next frame (as soon as the previous style change has taken effect),
        // explicitly set the element's height to its current pixel height, so we
        // aren't transitioning out of 'auto'
        requestAnimationFrame(function () {
          element.style.height = sectionHeight + "px";
          element.style.transition = elementTransition;

          // on the next frame (as soon as the previous style change has taken effect),
          // have the element transition to height: 0
          requestAnimationFrame(function () {
            element.style.height = 0 + "px";
          });
        });
      }
    }

    function expand(btn, element) {
      // let btn = p.querySelector("button");
      // let element = p.querySelector(".accordion__content");

      btn.setAttribute("aria-expanded", true);
      element.hidden = false;

      // get the height of the element's inner content, regardless of its actual size
      var sectionHeight = element.scrollHeight;

      // have the element transition to the height of its inner content
      element.style.height = sectionHeight + "px";

      function onTransitionEnd() {
        // remove this event listener so it only gets triggered once
        element.removeEventListener("transitionend", onTransitionEnd);

        // remove "height" from the element's inline styles, so it can return to its initial value
        element.style.height = null;
      }
      // when the next css transition finishes (which should be the one we just triggered)
      element.addEventListener("transitionend", onTransitionEnd);

      element.hidden = false;
    }

    const accordions = document.querySelectorAll("[data-accordion]");

    Array.prototype.forEach.call(accordions, (accordion) => {
      let btn = accordion.querySelector("[data-accordion-button]");
      let content = accordion.querySelector("[data-accordion-content]");
      // console.log(btn);
      // console.log(content);

      content.style.height = 0;

      btn.onclick = () => {
        accordion.classList.toggle("expanded");

        if (btn.getAttribute("aria-expanded") === "true") {
          collapse(btn, content);
        } else {
          expand(btn, content);
          // Array.prototype.forEach.call(popovers, (s) => {
          //   if (s != h) collapse(s);
          // });
        }
      };
    });
  },
  readMore: function () {
    const buttons = document.querySelectorAll(".read-more__button");

    buttons.forEach(function (button, idx, array) {
      button.onclick = () => {
        if (button.getAttribute("aria-expanded") === "true") {
          button.setAttribute("aria-expanded", false);
        } else {
          button.setAttribute("aria-expanded", true);
        }
      };
    });
  },
  duplicatePrevent: function () {
    // Prevent Double Submits
    document.querySelectorAll('form').forEach(form => {
      form.addEventListener('submit', (e) => {
          // Prevent if already submitting
          if (form.classList.contains('is-submitting')) {
            e.preventDefault();
          }
          
          // Add class to hook our visual indicator on
          form.classList.add('is-submitting');
        });
      });
  },
  loadHomeHero: function () {
    const heroImg = document.querySelectorAll(".hero--image");

    if (heroImg.length) {
      window.addEventListener("load", () => {
        heroImg[0].classList.add("hero--animate");
      });
    }
  },
  plugin: function () {
    //alert(123);
  },
  feedResourceFilters: function () {
    const widgets = document.querySelectorAll(".disclosure-widget");
    const filterButtonMobile = document.querySelector(".disclosure-button_mobile-filter");
    const filtersWrapper = document.getElementById("feed-resource-filters__wrapper");
    const checkboxAllIngredients = document.getElementById("checkbox-all-ingredients");

    // Ensure the necessary elements are present before proceeding
    if (widgets.length === 0 || !filterButtonMobile || !filtersWrapper) {
        return;
    }

    // Function to hide or show filters wrapper based on screen width
    const handleScreenResize = () => {
        if (window.innerWidth < 768) {
            filtersWrapper.style.display = "none";
        } else {
            filtersWrapper.style.display = "block";
        }
    };

    // Initial handling based on screen width
    handleScreenResize();

    // Event listener for screen resize
    window.addEventListener("resize", handleScreenResize);

    // Event listener for mobile filter button
    filterButtonMobile.addEventListener("click", () => {
        if (filtersWrapper.style.display === "none") {
            filtersWrapper.style.display = "block";
        } else {
            filtersWrapper.style.display = "none";
        }
    });

    widgets.forEach(function (element) {
        var btn = element.querySelector(".disclosure-button");
        var content = btn.nextElementSibling;

        btn.onclick = () => {
            slideAnim.slideStop(content);
            if (btn.getAttribute("aria-expanded") === "true") {
                btn.setAttribute("aria-expanded", false);
                slideAnim.slideUp(content, {
                    duration: 400,
                });
            } else {
                btn.setAttribute("aria-expanded", true);
                content.style.display = "none";
                content.hidden = false;
                slideAnim.slideDown(content, {
                    duration: 400,
                });
            }
        };
    });

    // Add an event listener to the "checkbox-all-ingredients" if it exists
    if (checkboxAllIngredients) {
        checkboxAllIngredients.addEventListener("change", function() {
            const allCheckboxes = document.querySelectorAll(".feed-ingredient-checkbox");
            allCheckboxes.forEach(function(checkbox) {
                checkbox.checked = checkboxAllIngredients.checked;
            });
        });

        // Check URL parameters to see if "all-ingredients" is present
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        const feedIngredients = [];
        for (const [key, value] of urlParams.entries()) {
            if (key.startsWith('feed_ingredient[')) {
                feedIngredients.push(value);
            }
        }

        if (feedIngredients.includes('all-ingredients')) {
            checkboxAllIngredients.checked = true;
        }
    }

    // Add event listeners to other feed ingredient checkboxes
    const feedIngredientCheckboxes = document.querySelectorAll(".feed-ingredient-checkbox:not(#checkbox-all-ingredients)");
    feedIngredientCheckboxes.forEach(function(checkbox) {
        checkbox.addEventListener("change", function() {
            if (!checkbox.checked && checkboxAllIngredients && checkboxAllIngredients.checked) {
                checkboxAllIngredients.checked = false;
            }
        });
    });
  },
  quoteCarousels: function () {
		(function ($) {
			//alert(0);

			$(".quote-carousel").each(function () {
				if ($(this).find(".glide__slide").length < 2) {
					return;
				}

				var glide = new Glide($(this)[0], {
					type: "carousel",
					perView: 1,
					autoplay: 5000,
					gap: 0,
					startAt: 0,
					rewind: false,
					focusAt: "center",
					dragThreshold: false,
				});

				glide.mount();
			});
		})(jQuery);
	},
  setCookie(name, value, days = 365, options = {}) {
    const { path = "/", domain, secure, sameSite = "Lax" } = options;

    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      cookieString += `; expires=${date.toUTCString()}`;
    }

    cookieString += `; path=${path}`;

    if (domain) {
      cookieString += `; domain=${domain}`;
    }

    if (secure) {
      cookieString += "; secure";
    }

    if (sameSite) {
      cookieString += `; samesite=${sameSite}`;
    }

    document.cookie = cookieString;
  },
  initDialogs() {
    // Make A11yDialog globally available
    window.A11yDialog = A11yDialog;

    const popupDialogs = document.querySelectorAll(".dialog-container");

    popupDialogs.forEach((dialogElement) => {
      const dialogDelay = dialogElement.dataset.dialogDelay;
      const dialogId = dialogElement.dataset.dialogId;
      const cookieName = "STYXKEY-popup-" + dialogId;
      const dialog = new A11yDialog(dialogElement);

      if (!dialogDelay) {
        return;
      }

      // Check if delayed popup was already dismissed
      if (document.cookie.indexOf(cookieName) !== -1) {
        return;
      }

      // Set cookie when dialog is shown
      dialog.on("show", function () {
        wmbb.setCookie(cookieName, true, 1);
      });

      // Show dialog after delay, during an idle period for better UX
      const delay = parseInt(dialogDelay) * 1000;
      setTimeout(() => {
        // Wait for browser idle time before showing popup
        // This prevents interrupting animations or user interactions
        if (window.requestIdleCallback) {
          requestIdleCallback(
            () => {
              dialog.show();
            },
            { timeout: 1000 } // Show within 1s even if browser stays busy
          );
        } else {
          // Fallback for browsers without requestIdleCallback support
          dialog.show();
        }
      }, delay);
    });
  },
  a11yTabs: function () {
    // Adapted from:
    // https://inclusive-components.design/tabbed-interfaces/
    // https://codepen.io/heydon/pen/veeaEa/

    const elements = document.querySelectorAll("[data-tabbed]");

    Array.prototype.forEach.call(elements, (tabbed) => {
      const tablist = tabbed.querySelector('[role="tablist"]');

      if (!tablist) {
        return;
      }

      const tabs = tablist.querySelectorAll("a");
      const orientation = tablist.getAttribute("aria-orientation");
      const panels = tabbed.querySelectorAll('[role="tabpanel"]');

      if (!tabs.length || tabs.length !== panels.length) {
        return;
      }

      const getHash = () => {
        try {
          return decodeURIComponent(window.location.hash.slice(1));
        } catch (error) {
          return window.location.hash.slice(1);
        }
      };

      const getTabIndexFromHash = () => {
        const hash = getHash();
        let index = -1;

        Array.prototype.some.call(panels, (panel, panelIndex) => {
          if (panel.id === hash) {
            index = panelIndex;
            return true;
          }

          return false;
        });

        return index === -1 ? 0 : index;
      };

      const activateTab = (index, options = {}) => {
        const { focus = false, updateHistory = false } = options;
        const tab = tabs[index];
        const panel = panels[index];

        if (!tab || !panel) {
          return;
        }

        if (focus) {
          tab.focus();
        }

        Array.prototype.forEach.call(tabs, (item, itemIndex) => {
          item.setAttribute("tabindex", itemIndex === index ? "0" : "-1");
          item.setAttribute("aria-selected", itemIndex === index ? "true" : "false");
          panels[itemIndex].hidden = itemIndex !== index;
        });

        if (updateHistory && window.location.hash !== `#${panel.id}`) {
          const url = new URL(window.location.href);
          url.hash = panel.id;
          history.pushState(null, "", url);
        }
      };

      Array.prototype.forEach.call(tabs, (tab, index) => {
        tab.setAttribute("role", "tab");
        tab.setAttribute("id", `${panels[index].id}-tab`);
        tab.setAttribute("aria-controls", panels[index].id);
        tab.setAttribute("tabindex", "-1");
        tab.parentNode.setAttribute("role", "presentation");

        tab.addEventListener("click", (event) => {
          event.preventDefault();
          activateTab(index, { focus: true, updateHistory: true });
        });

        tab.addEventListener("keydown", (event) => {
          const currentIndex = index;
          let nextIndex = null;

          if (event.key === "Home") {
            nextIndex = 0;
          } else if (event.key === "End") {
            nextIndex = tabs.length - 1;
          } else if (orientation === "vertical") {
            nextIndex = event.key === "ArrowUp"
              ? currentIndex - 1
              : event.key === "ArrowDown"
              ? currentIndex + 1
              : null;
          } else if (event.key === "ArrowLeft") {
            nextIndex = currentIndex - 1;
          } else if (event.key === "ArrowRight") {
            nextIndex = currentIndex + 1;
          } else if (event.key === "ArrowDown") {
            event.preventDefault();
            panels[currentIndex].focus();
            return;
          }

          if (nextIndex !== null && tabs[nextIndex]) {
            event.preventDefault();
            activateTab(nextIndex, { focus: true, updateHistory: true });
          }
        });
      });

      Array.prototype.forEach.call(panels, (panel, index) => {
        panel.setAttribute("tabindex", "-1");
        panel.setAttribute("aria-labelledby", tabs[index].id);
      });

      activateTab(getTabIndexFromHash());

      window.addEventListener("popstate", () => {
        activateTab(getTabIndexFromHash());
      });
    });
	},
  init: function () {
    wmbb.headerForm();
    wmbb.carousels();
    wmbb.modals();

    wmbb.mobileNav();

    wmbb.accordion();
    wmbb.newAccordion();
    wmbb.readMore();
    wmbb.loadHomeHero();
    wmbb.duplicatePrevent();

    wmbb.plugin();
    wmbb.feedResourceFilters();
    
    wmbb.quoteCarousels();
    wmbb.initDialogs();
    wmbb.a11yTabs();
  },
};
wmbb.init();

//google.maps.event.addDomListener(window, "load", initialize);
